module.exports = __webpack_public_path__ + "img/invoice-de-female-st.84aabd32.png";